import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af3814ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container media-room-wrapper" }
const _hoisted_2 = { class: "text-box" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["innerHTML"]

import { onMounted, ref } from 'vue';
  import MediaSection, { IProps } from './components/media-section.vue';
  import { useI18n } from 'vue-i18n';
  import { request } from '@/utils';

  interface SectionItem extends IProps {
    id: string
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const isKo = locale.value === 'ko';
  const sections = ref<SectionItem[]>([]);
  onMounted(async () => {
    const { data } = await request.get<SectionItem[]>('media', { params: { page: 0 } });
    sections.value = data;
  });


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      routes: [
        { name: _unref(t)('Home'), to: { name: 'home'} } ,
        { name: _unref(t)('Media Room'), to: { name: 'mediaRoom' } }
      ],
      style: {"margin":"2.35rem 0 3.15rem"}
    }, null, 8, ["routes"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Media Room')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          innerHTML: _unref(t)('desc[0]', { email: 'customersupport@terracycle.com' })
        }, null, 8, _hoisted_5),
        _hoisted_6,
        (!isKo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createElementVNode("span", {
                innerHTML: _unref(t)('desc[1]', { email: 'press@loopstore.com' })
              }, null, 8, _hoisted_8)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (item) => {
      return (_openBlock(), _createBlock(MediaSection, {
        key: item.id,
        name: item.name,
        desc: item.desc,
        files: item.files
      }, null, 8, ["name", "desc", "files"]))
    }), 128))
  ]))
}
}

})